import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import * as moment from 'moment';
import * as _ from 'underscore';
@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {

	private toasterService: ToasterService;
	public companies: Array<any>;
	public filteredItems: Array<any>;
	searchText = "";
	limit = 20;
	skip = 0;
	public pages: any = [];
	currentPage = 1;
	constructor(private apiService: ApiService, toasterService: ToasterService) {
		this.toasterService = toasterService;
		this.searchCompanies = _.debounce(this.searchCompanies, 1000);
	}

	ngOnInit() {
		if(! sessionStorage.getItem('access_token_nv_admin')) {
			window.open("/login", "_self");
		}
		let params:any = {
			skip: this.skip,
			limit: this.limit,
			name:''
		}
		this.apiService.getAllCompanies(params).subscribe((data:any) => {
			this.companies = data.data.companyData;
			var length = Math.ceil(data.data.totalCompanies/this.limit);
			this.pages = [];
			for (let i = 1; i <= length; i++) {
				this.pages.push(i)
			}
			this.filteredItems = data.data.companyData;
		},
		error => {
			if(error.statusText ==  "Unauthorized") {
				// this.toasterService.pop('error', 'Session Expired', 'Please login again');
				window.open("/logout", "_self");
			} else
			 this.toasterService.pop('error', error.error.message);
		});
		
		this.assignCopy();
	}

	assignCopy() {
		// this.filteredItems = Object.assign([], this.companies);
	}

	filterItem(value) {
		if (!value) 
			this.assignCopy();
		this.companies = Object.assign([], this.filteredItems).filter(
			item => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1
			)
	}

	updateCompany(id) {
		sessionStorage.setItem('company_id', id);
		window.open("/updatecompany", "_self");
	}

	setPage(page) {
		this.currentPage = page;
		this.skip = (this.currentPage - 1) * this.limit;
		if (!sessionStorage.getItem('access_token_nv_admin')) {
			window.open("/login", "_self");
		}

		let params:any = {
			skip: this.skip,
			limit: this.limit,
			name:''
		}
		this.apiService.getAllCompanies(params).subscribe((data:any) => {
			this.companies = data.data.companyData;
			this.pages.length = Math.ceil(data.data.totalCompanies / this.limit);
			this.filteredItems = data.data.companyData;
		},
			error => {
				if(error.statusText ==  "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
				 this.toasterService.pop('error', error.error.message);
			});

		// this.assignCopy();
	}

	searchCompanies() {
		this.limit = 10;
		this.skip = 0;
		this.currentPage = 1;
		if (this.searchText.trim().length > 0) {
			let params:any = {
				skip: this.skip,
				limit: this.limit,
		        name:this.searchText.trim()
			}
			this.apiService.getAllCompanies(params).subscribe((data:any) => {
				this.companies = data.data.companyData;
				var length = Math.ceil(data.data.companyData.length / this.limit);
				this.pages = [];
				for (let i = 1; i <= length; i++) {
					this.pages.push(i)
				}
				this.filteredItems = data.data.companyData;
				// this.pages.length = Math.ceil(data.data.totalCompanies / this.limit);
				// this.filteredItems = data.data.companyData;
			},
				error => {
					if (error.statusText == "Unauthorized") {
						// this.toasterService.pop('error', 'Session Expired', 'Please login again');
						window.open("/logout", "_self");
					} else
						 this.toasterService.pop('error', error.error.message);
				});


		} else {
			let params:any = {
				skip: this.skip,
				limit: this.limit,
				name:''
			}
			this.apiService.getAllCompanies(params).subscribe((data:any) => {
				this.companies = data.data.companyData;
				var length = Math.ceil(data.data.totalCompanies / this.limit);
				this.pages = [];
				for (let i = 1; i <= length; i++) {
					this.pages.push(i)
				}
				this.filteredItems = data.data.companyData;
			},
				error => {
					if (error.statusText == "Unauthorized") {
						// this.toasterService.pop('error', 'Session Expired', 'Please login again');
						window.open("/logout", "_self");
					} else
						 this.toasterService.pop('error', error.error.message);
				});
		}
		this.assignCopy();
	}

	convertDateToString(dateToBeConverted: string) {
		return moment(dateToBeConverted, "YYYY-MM-DD HH:mm:ss").format("LL");
	}

}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts